import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { ObservabilityService } from './observability.service';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  constructor(private injector: Injector) {}

  handleError(error: unknown): void {
    let obsService: ObservabilityService | null = null;
    try {
      obsService = this.injector.get(ObservabilityService);
    } catch {
      // Fallback if injector fails during bootstrap
    }

    const message = error instanceof Error ? error.message : String(error);
    const stack = error instanceof Error ? error.stack : undefined;
    const isChunkFailed = message.includes('Loading chunk') || message.includes('Failed to fetch dynamically imported module');

    const crashData = {
      at: new Date().toISOString(),
      url: typeof window !== 'undefined' ? window.location.href : 'unknown',
      message,
      stack,
      isChunkFailed,
      correlationId: typeof localStorage !== 'undefined' ? localStorage.getItem('correlation-id') : undefined
    };

    if (typeof localStorage !== 'undefined') {
      try {
        localStorage.setItem('h5-last-crash', JSON.stringify(crashData));
      } catch {
        // Storage full
      }
    }

    if (obsService) {
      obsService.error('GlobalErrorHandler', `Uncaught Application Error: ${message}`, error, crashData);
    } else {
      console.error('[GlobalErrorHandler]', crashData);
    }
  }
}

